import React, { useState, useEffect } from "react";
import "../Styles/style.css";
import "../ui/common.css";

const Testimonials = () => {
  const [showForm, setShowForm] = useState(false);
  const [bannerData, setBannerData] = useState(null);
  const [reviews, setReviews] = useState([]);

  // Helper function to strip HTML tags
  const stripHtmlTags = (html) => {
    if (!html) return "";
    const temp = document.createElement("div");
    temp.innerHTML = html;
    return temp.textContent || temp.innerText || "";
  };

  // Fetch Banner
  useEffect(() => {
    fetch(
      "/prosapiens-cms/public/api/banners/jobseekers-reviews",
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.banners && data.banners.length > 0) {
          setBannerData(data.banners[0]);
        }
      })
      .catch((err) => console.error("Error fetching banner:", err));
  }, []);

  // Fetch Reviews
  useEffect(() => {
    fetch(
      "/prosapiens-cms/public/api/content/jobseekers-reviews",
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.content && data.content.length > 0) {
          // Sort by content_order just in case
          const sorted = [...data.content].sort(
            (a, b) => Number(a.content_order) - Number(b.content_order),
          );
          setReviews(sorted);
        }
      })
      .catch((err) => console.error("Error fetching reviews:", err));
  }, []);

  // Function to clean HTML and format testimonial content
  const formatTestimonialContent = (content) => {
    // Remove all HTML tags
    const cleanText = content.replace(/<[^>]+>/g, "");
    // Split by new lines and filter out empty lines
    const lines = cleanText.split("\n").filter((line) => line.trim() !== "");
    return lines;
  };

  return (
    <div>
      {/* Banner */}
      {bannerData && (
        <section
          className="jobseekers-reviews-banner jobseekers-reviews-banne-mobile"
          style={{
            backgroundImage: `url(/prosapiens-cms/public/${bannerData.banner_image})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="overlay container">
            <div className="hero-text">
              <h1>{bannerData.banner_title}</h1>
              <div
                style={{ color: "#fff" }}
                dangerouslySetInnerHTML={{ __html: bannerData.content_text }}
              />
            </div>
          </div>
        </section>
      )}

      {/* Testimonials */}
      <div className="container testimonial-wrapper">
        {reviews.map((review) => {
          const formattedContent = formatTestimonialContent(
            review.content_text,
          );
          const country =
            formattedContent.length > 0 ? formattedContent[0] : "";
          const testimonialText =
            formattedContent.length > 1
              ? formattedContent.slice(1).join("\n")
              : "";

          return (
            <div
              className="testimonial-card"
              key={review.id}
              style={{
                background: "#fff",
                padding: "1.5rem",
                borderRadius: "12px",
                boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
              }}
            >
              <div
                className="testimonial-header"
                style={{ display: "flex", alignItems: "center", gap: "1rem" }}
              >
                <img
                  src={`/prosapiens-cms/public/${review.content_image}`}
                  alt={review.content_title}
                  style={{
                    width: "60px",
                    height: "60px",
                    borderRadius: "50%",
                    objectFit: "cover",
                  }}
                />
                <div className="user-info">
                  <h3
                    style={{ margin: 0, fontSize: "1rem", fontWeight: "600" }}
                  >
                    {stripHtmlTags(review.content_title)}
                  </h3>
                  {country && (
                    <p
                      style={{
                        margin: "0.25rem 0 0",
                        fontSize: "0.85rem",
                        color: "#666",
                      }}
                    >
                      {country}
                    </p>
                  )}
                </div>
              </div>
              {testimonialText && (
                <div
                  className="testimonial-content"
                  style={{
                    marginTop: "1rem",
                    fontSize: "0.9rem",
                    color: "#444",
                    lineHeight: "1.6",
                    whiteSpace: "pre-line", // Preserves line breaks
                  }}
                >
                  {testimonialText}
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* Feedback Form Button */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "2rem",
          marginBottom: "3rem",
        }}
      >
        <button className="cta-yellow" onClick={() => setShowForm(true)}>
          SUBMIT YOUR FEEDBACK
        </button>
      </div>

      {/* Feedback Form Popup */}
      {showForm && (
        <div className="popup-form-overlay">
          <div className="popup-form">
            <h2>Submit Your Review</h2>
            <form>
              <div className="form-row two-cols">
                <input type="text" placeholder="Full Name" required />
                <input type="email" placeholder="Email ID" required />
              </div>
              <div className="form-row two-cols">
                <input type="text" placeholder="Designation" required />
                <input type="text" placeholder="Company Name" required />
              </div>
              <div className="form-row">
                <label>Upload your photo</label>
                <input type="file" accept="image/*" />
              </div>
              <div className="form-row">
                <label>Message</label>
                <textarea
                  rows="4"
                  placeholder="Write your review..."
                  required
                ></textarea>
              </div>
              <button type="submit" className="submit-btn">
                SUBMIT
              </button>
            </form>
            <span className="close-btn" onClick={() => setShowForm(false)}>
              Close
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default Testimonials;
